<template>
  <small-modal
    :title="title"
    class="embed-code-modal-wrapper"
    :fit-content="true"
    @close="close"
  >
    <h2 class="subtitle"><span>Account:</span> {{ account }}</h2>
    <div class="modal-body">
      <textarea v-model="text" spellcheck="false"></textarea>
      <transition name="fade-error">
        <p v-if="error" class="json-error">{{ error }}</p>
      </transition>
    </div>

    <div class="modal-footer">
      <div class="modal-action-buttons">
        <button class="submit-button back-button" @click="close">
          {{ $t("campaignManager.tags.deleteTagModal.cancel") }}
        </button>
        <button class="button-primary button-flex" @click="onSave">
          {{ $t("create.bulk.modalButtons.confirm") }}
        </button>
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal";

export default {
  components: {
    SmallModal,
  },
  props: {
    visible: { type: Boolean, default: false },
    plan: { type: Object, required: true },
    title: { type: String, default: "Edit plan" },
    account: { type: String, default: "Account" },
    readOnlyKeys: {
      type: Array,
      default: () => ["_id", "siteId"],
    },
  },
  data() {
    return {
      text: JSON.stringify(this.plan || {}, null, 2),
      error: "",
      errorTimeoutId: null,
    };
  },
  computed: {
    title() {
      return "Update account limits from JSON";
    },
  },
  watch: {
    visible(v) {
      if (v) {
        this.text = JSON.stringify(this.plan || {}, null, 2);
        this.error = "";
      }
    },
    plan(val) {
      this.text = JSON.stringify(val || {}, null, 2);
      this.error = "";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      try {
        const parsed = JSON.parse(this.text);

        const err = this.validatePlan(parsed, this.plan, this.readOnlyKeys);
        if (err) {
          this.error = err;
          return;
        }

        this.$emit("save", parsed);
        this.close();
      } catch (e) {
        this.showError(e?.message || "Invalid JSON");
      }
    },
    validatePlan(next, original, roKeys) {
      if (typeof next !== "object" || next === null) {
        return "Plan must be a JSON object";
      }

      for (const k of roKeys) {
        if (String(next?.[k]) !== String(original?.[k])) {
          return `Field "${k}" is read-only and cannot be changed.`;
        }
      }
      return "";
    },
    showError(msg) {
      this.error = msg;
      this.clearErrorTimeout();
      this.errorTimeoutId = setTimeout(() => {
        this.error = "";
        this.errorTimeoutId = null;
      }, 5000);
    },
    clearErrorTimeout() {
      if (this.errorTimeoutId) {
        clearTimeout(this.errorTimeoutId);
        this.errorTimeoutId = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.subtitle {
  @include base-font;
  @include font-normal;
  text-align: center;
  margin-bottom: 16px;
  span {
    font-weight: 600;
  }
}
.modal-body {
  padding: 12px 16px;
  overflow: auto;
}
.modal-body textarea {
  @include base-font;
  @include font-smaller;
  line-height: 21px;
  width: 600px;
  min-height: 300px;
  padding: 10px;
  border-radius: 6px;
  border: none;
  outline: none;
  border: 1px solid $light-grey;
}
.json-error {
  text-align: center;
  margin-top: 24px;
  color: #b00020;
  font-weight: 600;
}
.modal-action-buttons {
  display: flex;
  justify-content: center;
  gap: 80px;
}
.submit-button {
  @include base-font;
  @include font-small;
  font-weight: 500;
  width: 115px;
  height: 36px;
  background: transparent;
  border-radius: 20px;
  box-shadow: 2px 2px 15px 0px $dark-purple;
  &:hover {
    background-color: $dark-purple;
    color: white;
  }
}
.back-button {
  box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.18);
  &:hover {
    background-color: rgba(0, 0, 0, 0.18);
  }
}
</style>
